var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSupportSvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 282,
    height: 282,
    viewBox: "0 0 282 282",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M256.379 139.556C253.678 162.454 243.221 189.081 222.336 201.308C190.786 219.791 193.426 248.222 131.843 260.579C122.243 262.508 113.129 263.32 104.539 263.157C99.9202 263.072 95.4477 262.7 91.1388 262.062C51.9972 256.344 25.6584 229.142 15.997 196.3C3.27884 153.109 28.6701 124.83 45.5055 107.797C62.3353 90.7587 74.6643 37.6751 135.108 25.0527C144.324 23.1295 153.748 22.1538 163.173 22.385C184.678 22.9152 208.135 29.9765 224.367 44.7138C225.585 45.8192 226.769 46.9698 227.926 48.1542C250.486 71.312 260.074 108.339 256.385 139.556H256.379Z",
    fill: "#A7D4FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M256.379 139.556C253.678 162.454 243.221 189.081 222.336 201.308C190.786 219.791 193.426 248.222 131.843 260.579C122.243 262.508 113.129 263.32 104.539 263.157C99.9202 263.072 95.4477 262.7 91.1388 262.062C51.9972 256.343 25.6584 229.142 15.997 196.3C3.27884 153.109 28.6701 124.83 45.5055 107.797C62.3353 90.7587 74.6643 37.6751 135.108 25.0527C144.324 23.1295 153.748 22.1538 163.173 22.385C184.678 22.9152 208.135 29.9765 224.367 44.7138C225.585 45.8192 226.769 46.9698 227.926 48.1542C250.486 71.312 260.074 108.339 256.385 139.556H256.379Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M238.578 238.347V174.699",
    stroke: "#A7D4FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M233.414 238.347V206.785",
    stroke: "#A7D4FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M240.189 185.133C240.189 185.133 234.989 184.535 232.874 180.418C230.759 176.301 230.539 165.681 238.638 153.938C246.737 142.196 250.984 142.043 252.394 151.648C253.804 161.253 253.601 175.201 250.29 180.486C246.974 185.77 240.195 185.133 240.195 185.133H240.189Z",
    fill: "white",
    stroke: "#A7D4FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M242.031 162.964C242.99 159.693 244.135 156.749 245.466 154.758",
    stroke: "#A7D4FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M238.023 184.401C238.023 184.401 239.095 174.13 241.419 165.18",
    stroke: "#A7D4FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M243.287 205.793C243.287 205.793 239.948 203.204 240.219 199.482C240.484 195.76 244.776 188.343 255.278 183.639C265.779 178.935 268.768 180.605 265.717 187.818C262.666 195.032 256.693 204.564 252.192 206.82C247.692 209.076 243.287 205.799 243.287 205.799V205.793Z",
    fill: "white",
    stroke: "#A7D4FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M253.836 191.277C255.866 189.422 257.885 187.871 259.639 187.059",
    stroke: "#A7D4FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M252.489 192.551C247.137 197.751 242.101 204.378 242.101 204.378C242.101 204.378 239.41 207.993 238.609 215.19",
    stroke: "#A7D4FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M241.372 227.316C241.372 227.316 239.437 225.815 239.595 223.661C239.747 221.506 242.235 217.209 248.32 214.479C254.406 211.755 256.137 212.719 254.372 216.899C252.607 221.078 249.144 226.599 246.538 227.908C243.932 229.216 241.377 227.316 241.377 227.316H241.372Z",
    fill: "white",
    stroke: "#A7D4FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M247.484 218.905C248.663 217.833 249.831 216.931 250.846 216.457",
    stroke: "#A7D4FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M246.709 219.645C243.607 222.656 240.691 226.497 240.691 226.497C240.691 226.497 239.134 228.595 238.672 232.763",
    stroke: "#A7D4FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M233.86 197.188C233.86 197.188 237.199 194.599 236.929 190.876C236.664 187.154 232.371 179.737 221.87 175.034C211.368 170.33 208.379 171.999 211.43 179.213C214.481 186.426 220.454 195.958 224.955 198.214C229.456 200.47 233.86 197.193 233.86 197.193V197.188Z",
    fill: "white",
    stroke: "#A7D4FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M223.311 182.672C221.281 180.816 219.262 179.265 217.508 178.453",
    stroke: "#A7D4FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M224.656 183.945C230.009 189.145 235.045 195.772 235.045 195.772C235.045 195.772 237.735 199.388 238.536 206.584",
    stroke: "#A7D4FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M232.221 225.934C232.221 225.934 235.599 226.041 237.291 224.005C238.983 221.969 239.998 216.289 235.768 209.318C231.544 202.353 228.837 201.924 227.15 206.961C225.458 211.997 224.443 219.504 226.135 222.612C227.827 225.72 232.221 225.934 232.221 225.934Z",
    fill: "white",
    stroke: "#A7D4FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M232.75 220.758C232.801 221.452 232.835 222.14 232.852 222.828",
    stroke: "#A7D4FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M230.156 206.656C230.156 206.656 231.927 212.657 232.604 219.138",
    stroke: "#A7D4FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0391 184.822H92.1023V25.4922",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M174.946 184.822H96.8828V25.4922",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M128.742 184.822H206.805V25.4922",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M190.872 62.9023L163.586 93.0538",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M175.733 86.2305L168.164 94.5946",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M115.597 54.9844L100.859 71.2671",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M119.578 51.0193L129.538 40.0156",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M88.9114 151.812L79.3516 162.376",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M85.7265 137.73L68 157.318",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M180.351 50.7577C183.143 43.7728 179.744 35.8468 172.759 33.0544C165.774 30.2621 157.848 33.6608 155.056 40.6457C152.264 47.6306 155.662 55.5566 162.647 58.349C169.632 61.1413 177.558 57.7426 180.351 50.7577Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M167.709 57.5937C174.275 57.5937 179.598 52.271 179.598 45.7051C179.598 39.1391 174.275 33.8164 167.709 33.8164C161.143 33.8164 155.82 39.1391 155.82 45.7051C155.82 52.271 161.143 57.5937 167.709 57.5937Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M167.703 46.5203C168.152 46.5203 168.516 46.1563 168.516 45.7074C168.516 45.2585 168.152 44.8945 167.703 44.8945C167.255 44.8945 166.891 45.2585 166.891 45.7074C166.891 46.1563 167.255 46.5203 167.703 46.5203Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M167.703 46.5195V50.5132",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M166.898 45.7031H157.203",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M110.975 133.791L101.681 119.37C105.64 112.974 107.935 105.439 107.935 97.3623C107.935 74.2439 89.1937 55.5078 66.081 55.5078C42.9683 55.5078 24.2266 74.2495 24.2266 97.3623C24.2266 120.475 42.9683 139.217 66.081 139.217C78.2972 139.217 89.2896 133.983 96.9431 125.63L110.981 133.791H110.975Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M111.858 130.256L102.563 115.834C106.523 109.439 108.818 101.904 108.818 93.8271C108.818 70.7087 90.0765 51.9727 66.9638 51.9727C43.8511 51.9727 25.1094 70.7144 25.1094 93.8271C25.1094 116.94 43.8511 135.682 66.9638 135.682C79.1801 135.682 90.1724 130.442 97.8259 122.095L111.864 130.256H111.858Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M186.503 180.574H216.716C216.716 180.574 200.383 220.793 203.446 238.756H172.82C172.82 238.756 178.539 192.824 186.497 180.574H186.503Z",
    fill: "#87D7FF",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M160.357 122.845C160.357 122.845 160.661 128.288 170.791 131.469C180.926 134.644 191.207 131.469 196.955 136.009C202.702 140.549 202.549 147.503 200.587 150.983C198.624 154.463 195.443 157.943 204.822 162.026C214.202 166.11 208.601 178.061 204.67 182.443C200.739 186.831 193.932 188.946 186.368 187.435C178.805 185.923 169.883 167.621 160.204 157.943C150.526 148.265 149.342 130.397 155.518 125.276C161.688 120.155 160.357 122.857 160.357 122.857V122.845Z",
    fill: "black",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M158.804 103.266C158.804 103.266 162.977 101.444 164.049 104.981C165.121 108.517 165.442 118.144 165.442 118.144L163.192 117.609C163.192 117.609 163.728 106.689 161.263 104.981C158.804 103.266 156.875 107.124 156.875 107.124L158.804 103.272V103.266Z",
    fill: "#A6A6A6",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M111.953 220.736L126.211 213.11C126.211 213.11 125.224 198.147 125.365 197.583C125.506 197.019 129.076 167.742 129.076 167.742L119.291 196.737L111.953 220.736Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M174.986 152.709C174.986 152.709 189.064 160.385 190.981 161.186C192.899 161.987 191.782 171.744 191.782 178.14C191.782 184.536 182.183 238.601 182.183 238.601H111.164C111.164 238.601 123.16 220.209 123.482 215.409C123.803 210.609 121.722 206.774 121.401 202.132C121.079 197.491 127.96 169.183 129.077 167.74C130.199 166.301 134.993 162.618 134.993 162.618L151.947 147.74L159.786 145.98L174.981 152.698L174.986 152.709Z",
    fill: "#A7D4FF",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M127.923 220.613L125.555 225.486",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M130.198 206.613C130.198 206.613 126.678 209.01 128.438 210.291C130.198 211.571 130.999 214.289 130.999 214.289L128.748 218.683",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M146.773 218.25C147.727 218.323 148.731 218.374 149.78 218.408",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M131.633 214.289C131.633 214.289 135.457 216.85 143.804 217.944",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M122.089 112.042C122.089 112.042 119.945 112.9 119.945 115.68C119.945 118.461 122.196 123.92 122.196 123.92L123.482 123.492C123.482 123.492 121.13 117.818 121.446 115.787C121.767 113.751 123.696 113.221 123.696 113.221L123.267 111.828L122.089 112.042Z",
    fill: "#A6A6A6",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M127.596 126.375C128.143 129.189 127.195 131.738 125.481 132.071C123.766 132.404 121.939 130.39 121.397 127.576C120.85 124.762 121.798 122.212 123.512 121.88C125.227 121.547 127.054 123.56 127.596 126.375Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M132.799 125.465C133.865 129.063 132.619 132.605 130.013 133.383C127.407 134.156 124.429 131.866 123.358 128.268C122.292 124.669 123.538 121.127 126.144 120.349C128.75 119.576 131.727 121.866 132.799 125.465Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M142.461 145.081L144.993 153.315L136.663 163.805L135.281 171.91C135.281 171.91 133.899 195.04 134.689 198.599C135.479 202.157 135.479 203.144 135.479 203.144C135.479 203.144 152.675 183.179 161.174 170.923C169.674 158.667 171.654 151.155 171.654 151.155L163.352 146.609L159.398 128.223L142.461 145.081Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M155.592 137.113L144.994 153.317L142.039 143.78L155.592 137.113Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M135.36 171.453L135.281 171.916C135.281 171.916 133.899 195.045 134.689 198.604C135.479 202.163 135.479 203.15 135.479 203.15C135.479 203.15 152.675 183.184 161.174 170.929C161.84 169.97 162.46 169.039 163.053 168.137C152.41 171.78 141.559 171.842 135.36 171.453Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M131.185 94.5984C131.185 94.5984 123.267 99.415 122.41 106.691C121.552 113.966 124.553 121.783 125.726 124.885C126.905 127.987 130.971 140.085 133.109 142.437C135.246 144.789 142.206 148.325 143.385 148.968C144.564 149.611 146.701 149.397 148.523 148.111C150.345 146.825 157.834 137.727 159.013 135.59C160.192 133.447 160.406 128.737 160.406 128.737C160.406 128.737 160.192 119.319 159.763 113.216C159.335 107.114 159.656 101.225 154.625 96.093C149.594 90.955 136.109 90.8478 131.185 94.5928V94.5984Z",
    fill: "white",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M159.763 113.22C159.334 107.117 159.656 101.235 154.625 96.0969C149.594 90.9589 136.109 90.8517 131.185 94.5967C131.185 94.5967 123.266 99.4132 122.409 106.689C121.913 110.919 122.714 115.318 123.706 118.883C125.528 117.777 131.67 113.993 138.573 109.154C146.813 103.373 149.492 94.3823 149.492 94.3823C149.492 94.3823 150.457 93.8465 150.243 95.0253C150.028 96.2041 146.819 103.158 145.64 104.23L144.462 105.301C144.462 105.301 145.426 105.087 149.814 110.332C154.202 115.577 156.666 117.715 157.947 118.358C158.347 118.555 159.137 118.696 160.073 118.775C159.988 116.852 159.887 114.912 159.768 113.22H159.763Z",
    fill: "black",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M146.581 124.569C146.722 125.353 146.429 126.063 145.938 126.148C145.442 126.232 144.929 125.668 144.793 124.884C144.652 124.101 144.946 123.39 145.436 123.305C145.927 123.221 146.446 123.785 146.581 124.569Z",
    fill: "#263238",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M134.589 126.28C134.73 127.064 134.437 127.774 133.946 127.859C133.45 127.943 132.936 127.379 132.801 126.595C132.66 125.811 132.953 125.101 133.444 125.016C133.94 124.932 134.454 125.496 134.589 126.28Z",
    fill: "#263238",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M141.672 119.747C141.672 119.747 145.203 116.967 148.417 119.211",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M134.504 121.247C134.504 121.247 130.331 119.211 127.438 122.854",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M135.25 121.355C135.25 121.355 138.138 122.749 138.352 125.422",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M138.461 132.809C138.461 132.809 139.64 133.666 141.67 133.023",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M137.602 137.303C137.602 137.303 140.811 137.303 144.561 135.696C148.306 134.088 149.807 131.844 149.807 131.844",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M139.428 137.198C139.428 137.198 140.606 138.377 142.53 138.377C144.453 138.377 146.167 134.953 146.167 134.953C146.167 134.953 141.244 137.096 139.422 137.203L139.428 137.198Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M161.689 129.272C164.409 129.272 166.613 126.229 166.613 122.476C166.613 118.722 164.409 115.68 161.689 115.68C158.97 115.68 156.766 118.722 156.766 122.476C156.766 126.229 158.97 129.272 161.689 129.272Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M163.776 126.491C165.52 126.491 166.934 124.168 166.934 121.302C166.934 118.436 165.52 116.113 163.776 116.113C162.031 116.113 160.617 118.436 160.617 121.302C160.617 124.168 162.031 126.491 163.776 126.491Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M125.484 129.73C125.484 129.73 125.513 140.847 128.406 141.811C131.294 142.776 139.218 140.847 139.218 140.847",
    stroke: "#263238",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M143.278 140.797C143.278 141.654 142.223 142.348 140.92 142.348C139.617 142.348 138.562 141.654 138.562 140.797C138.562 139.94 139.617 139.246 140.92 139.246C142.223 139.246 143.278 139.94 143.278 140.797Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M143.955 153.828C143.955 153.828 140.594 159.744 138.197 177.341C135.8 194.938 137.396 198.457 137.396 198.457L134.034 200.539C134.034 200.539 126.996 199.738 129.398 183.105C131.795 166.467 133.076 163.749 133.076 163.749L143.955 153.834V153.828Z",
    fill: "#A7D4FF",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M165.387 147.748C165.387 147.748 157.711 165.982 149.713 177.341C141.716 188.7 130.836 205.011 130.836 205.011C130.836 205.011 136.594 202.292 148.749 193.172C160.903 184.053 173.221 163.1 174.501 161.019C175.781 158.938 177.699 154.138 177.699 154.138L165.381 147.742L165.387 147.748Z",
    fill: "#A7D4FF",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M98.939 228.778C98.939 228.778 96.6491 230.25 93.0508 231.722C89.4525 233.194 89.1197 232.929 90.2703 234.175C91.4208 235.422 97.4669 233.194 99.1025 232.54C100.738 231.885 103.846 230.904 103.846 230.904C103.846 230.904 107.608 233.03 109.897 233.685C112.187 234.339 114.968 233.357 114.968 233.357C114.968 233.357 115.131 230.74 113.169 229.268C111.206 227.796 106.953 224.362 105.481 224.525C104.009 224.689 98.939 228.778 98.939 228.778Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M97.9573 224.853C97.9573 224.853 95.9945 224.362 94.6861 225.344C93.3776 226.325 91.9055 229.433 91.742 230.251C91.5784 231.068 91.9055 231.559 93.214 230.414C94.5225 229.269 96.8124 227.634 96.8124 227.634L98.7751 226.979L97.9573 224.853Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M103.024 223.383C103.024 223.383 99.0988 222.075 98.281 223.22C97.4632 224.365 94.6826 230.907 95.5004 231.398C96.3182 231.888 97.4632 230.907 98.9352 228.781C100.407 226.654 101.225 225.509 101.225 225.509L103.188 225.182L103.024 223.383Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M110.042 224.849C110.042 224.849 104.921 220.85 103.646 221.809C102.366 222.767 98.2093 229.005 97.7299 230.286C97.2505 231.566 99.4895 230.923 101.249 229.327C103.009 227.725 105.09 225.965 105.09 225.965L109.089 228.046L110.048 224.849H110.042Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M128.438 227.888C128.438 227.888 121.72 227.567 119.002 226.608C116.283 225.649 110.847 223.568 109.245 223.732C107.643 223.89 101.569 229.812 100.288 231.092C99.0082 232.372 99.1379 232.716 100.418 232.874C101.698 233.032 104.767 230.928 106.21 229.812C107.649 228.689 109.087 228.052 109.087 228.052C109.087 228.052 111.326 231.25 112.928 232.688C114.529 234.126 118.365 235.249 119.808 235.085C121.247 234.927 122.527 234.606 122.527 234.606L127.964 234.448L128.443 227.888H128.438Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M175.139 181.658C175.139 181.658 169.223 188.539 169.539 190.936C169.86 193.333 170.018 195.735 170.018 195.735L165.698 221.809C165.698 221.809 162.021 220.049 162.021 221.487V222.926L127.47 226.445L127.148 238.599L182.172 238.757C182.172 238.757 184.891 235.717 185.212 234.6C185.534 233.478 191.608 214.127 193.21 193.812C194.812 173.497 194.011 164.382 193.21 162.781C192.409 161.179 182.973 158.145 182.973 158.145",
    fill: "#A7D4FF"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M175.139 181.658C175.139 181.658 169.223 188.539 169.539 190.936C169.86 193.333 170.018 195.735 170.018 195.735L165.698 221.809C165.698 221.809 162.021 220.049 162.021 221.487V222.926L127.47 226.445L127.148 238.599L182.172 238.757C182.172 238.757 184.891 235.717 185.212 234.6C185.534 233.478 191.608 214.127 193.21 193.812C194.812 173.497 194.011 164.382 193.21 162.781C192.409 161.179 182.973 158.145 182.973 158.145",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M166.984 221.652C166.984 221.652 172.106 225.014 175.14 225.809Z",
    fill: "white"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M166.984 221.652C166.984 221.652 172.106 225.014 175.14 225.809",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M119.006 189.203L122.954 176.553C122.954 176.553 125.458 174.173 127.121 171.313C128.785 168.454 128.791 163.096 128.548 162.142C128.312 161.189 132 156.903 133.077 155.352C134.149 153.801 134.747 151.065 133.314 149.041C131.887 147.016 131.171 150.349 130.218 151.9C129.265 153.451 125.931 154.997 125.931 154.997L122.356 157.856C122.356 157.856 116.518 162.977 116.163 163.693C115.808 164.41 115.091 166.671 115.091 166.671L115.565 173.58L112.469 185.61L119 189.209L119.006 189.203Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M119.977 153.684C119.977 153.684 122.836 149.155 123.671 147.728C124.505 146.301 125.814 140.582 126.649 140.938C127.483 141.293 128.318 143.199 128.076 145.704C127.839 148.208 124.861 153.921 124.861 153.921L119.977 153.684Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M113.07 182.037L115.574 173.577L114.503 159.996L117.836 153.561L127.007 152.371C127.007 152.371 132.607 155.349 133.081 155.349C133.555 155.349 133.081 156.657 132.009 156.9C130.938 157.137 128.913 156.545 128.913 156.545L132.365 158.806C132.365 158.806 132.128 159.878 131.293 160.115C130.458 160.352 128.789 160.352 128.789 160.352C128.789 160.352 131.767 162.258 131.051 162.613C130.334 162.969 129.5 163.087 128.789 163.087H126.527L124.739 162.85L121.998 163.922C121.998 163.922 123.905 168.806 123.786 171.186C123.668 173.566 120.69 175.117 120.69 175.117",
    fill: "white"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M113.07 182.037L115.574 173.577L114.503 159.996L117.836 153.561L127.007 152.371C127.007 152.371 132.607 155.349 133.081 155.349C133.555 155.349 133.081 156.657 132.009 156.9C130.938 157.137 128.913 156.545 128.913 156.545L132.365 158.806C132.365 158.806 132.128 159.878 131.293 160.115C130.458 160.352 128.789 160.352 128.789 160.352C128.789 160.352 131.767 162.258 131.051 162.613C130.334 162.969 129.5 163.087 128.789 163.087H126.527L124.739 162.85L121.998 163.922C121.998 163.922 123.905 168.806 123.786 171.186C123.668 173.566 120.69 175.117 120.69 175.117",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M128.908 156.543C128.908 156.543 127.002 154.992 125.93 154.992C124.858 154.992 118.305 156.182 118.305 156.182",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M128.791 160.357C128.791 160.357 125.694 158.688 124.741 158.688C123.788 158.688 116.281 160.594 116.281 160.594",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M113.216 179.379L122.889 185.893C122.889 185.893 118.585 209.023 118.157 210.997C117.734 212.971 114.626 218.193 113.075 219.75C111.524 221.301 109.686 221.019 105.45 219.891C101.214 218.763 97.5426 215.373 97.6836 210.997C97.8246 206.62 113.211 179.379 113.211 179.379H113.216Z",
    fill: "#A7D4FF",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M63.2228 235.426H60.4141V236.289H63.2228V235.426Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M67.1212 235.426H64.3125V236.289H67.1212V235.426Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M71.0118 235.426H68.2031V236.289H71.0118V235.426Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M74.9103 235.426H72.1016V236.289H74.9103V235.426Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M78.8009 235.426H75.9922V236.289H78.8009V235.426Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M82.6915 235.426H79.8828V236.289H82.6915V235.426Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M86.5822 235.426H83.7734V236.289H86.5822V235.426Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M90.4728 235.426H87.6641V236.289H90.4728V235.426Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3634 235.426H91.5547V236.289H94.3634V235.426Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M98.254 235.426H95.4453V236.289H98.254V235.426Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M102.152 235.426H99.3438V236.289H102.152V235.426Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M106.043 235.426H103.234V236.289H106.043V235.426Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M109.934 235.426H107.125V236.289H109.934V235.426Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M113.832 235.426H111.023V236.289H113.832V235.426Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M117.723 235.426H114.914V236.289H117.723V235.426Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M121.613 235.426H118.805V236.289H121.613V235.426Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M128.397 236.109H58.8047V238.557H128.397V236.109Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M128.388 236.109H101.711V238.557H128.388V236.109Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M80.5207 214.671H25.807L14.8203 156.488H69.534L80.5207 214.671Z",
    fill: "#263238",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M78.858 213.199H25.7799L15.3516 157.961H68.424L78.858 213.199Z",
    fill: "#263238",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M68.64 208.799H29.1769L21.4219 167.734H60.885L68.64 208.799Z",
    fill: "#263238",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4202 167.735L15.3516 157.961",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M60.8828 167.735L68.4235 157.961",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M68.6406 208.801L78.8603 213.2",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1765 208.801L25.7812 213.2",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2189 196.497H36.2344L41.9533 191.398H50.9379L45.2189 196.497Z",
    fill: "#263238",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0262 235.492H42.1562V238.758H75.0262V235.492Z",
    fill: "#263238",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M56.2451 238.761H47.2606L36.2344 226.234H45.2189L56.2451 238.761Z",
    fill: "#263238",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2189 196.707H36.2344V226.103H45.2189V196.707Z",
    fill: "#263238",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M176.766 233.168C176.766 233.168 178.367 236.529 182.366 238.605Z",
    fill: "white"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M176.766 233.168C176.766 233.168 178.367 236.529 182.366 238.605",
    stroke: "#A7D4FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M7.92969 238.758H265.232",
    stroke: "#A7D4FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupportSvg);
export default __webpack_public_path__ + "static/media/support-svg.a11d09ad52528ee4c734ae0be3b32a21.svg";
export { ForwardRef as ReactComponent };